import { ComposeViewState, ComposeControl } from 'owa-mail-compose-store';
import { getTotalRecipientCount } from './viewStateUtils';

export default function getAutoFocusControl(viewState: ComposeViewState): ComposeControl {
    if (!viewState.selectionPath && !viewState.isInlineCompose) {
        if (getTotalRecipientCount(viewState) == 0) {
            return ComposeControl.RecipientWellTo;
        } else if (!viewState.subject) {
            return ComposeControl.SubjectLine;
        }
    }

    return ComposeControl.Editor;
}
